import keyMirror from 'keymirror';

const types = keyMirror({
	SET_AUTH_INFO: null,
	REMOVE_AUTH_INFO: null,
	ATTEMP_LOGIN: null,
	AUTH_FAIL: null
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/AuthConstants.js